import React, {Fragment} from 'react';
import {connect} from 'react-redux';

import Aqp from '../../libs/mk-react-aqp';

import {fetchMedias, resetMedias} from "../../creators/medias";

import Thumb from '../components/Thumb';
import Pagination from '../components/Pagination';
import {LoadingBar, PageLoader} from '../components/Loader';
import Title from "../components/Title";
import Dropdown from "../components/Dropdown";
import {Button} from "../components/Button";
import Toggle from "../components/Toggle";
import Upload from "../components/upload/Uploads";
import SubControls from "../components/SubControls";
import Modal from "../components/Modal";
import {Can} from "../../ability-context";
import createLink from "../../libs/createLink";
import Helmet from "react-helmet";
import {config} from "../../config";
import {canonical} from "../../libs/helper";
import MobileLiveTool from "../components/marketing/MobileLiveTool";
import Advertising from "../components/Advertising/Advertising";
import TagModerationQualificationWarning
    from "../components/TagModerationQualificationWarning/TagModerationQualificationWarning";


let mapping = {
    'currentYear': 'annee',
    'currentMonth': 'mois',
    'isCreator': 'createurs',
    // 'isMan': 'hommes',
    // 'isWoman': 'femmes',
    // 'isCouple': 'couples',
    'isFriends': 'mes-amis',
    // 'isTrans' : 'trav-trans',
};

class Photo extends React.Component {
    constructor(props) {
        super(props);
        this.sort = [{id : 1, title : 'Plus populaires'}/*, {id : 4, title : 'de commentaires'}*/, {id : 0 , title : 'Plus récentes'}];
        this.filter = {
            limit: 30,
            sort: 1,
            page: 1,
            kind: "gallery",
            isCreator: false,
            isFriends: false,
            gender: [],
            // isMan: false,
            // isWoman: false,
            // isCouple: false,
            // isTrans: false,
            period: 0,
            currentYear: "",
            currentMonth: "",
        };
        this.aqp = new Aqp(mapping, {
            blacklist: ['limit', 'page', 'kind'],
            currentLink: createLink('photos'),
            filterDefault: this.filter
        });

        let gender = this.aqp.query.gender || [];
        gender = Array.isArray(gender) ? gender : [gender];
        let sort = this.aqp.query.sort ? parseInt(this.aqp.query.sort) :  1;
        this.state = {
            filter: {...this.filter, ...this.aqp.query, gender, sort, page: this.props.match.params.page || 1},
        };

        this.handleChangePage = this.handleChangePage.bind(this);
        this.handleFilter = this.handleFilter.bind(this);
        this.handlePeriod = this.handlePeriod.bind(this);

        this.getMedias(this.state.filter);
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    componentWillUnmount() {
        this.props.resetMedias();
        this.setState({filter: this.filter});
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps.location.search !== this.props.location.search && this.props.location.search.length === 0 && prevProps.location.search !== "?"){
            this.getMedias(this.filter);
            this.setState({filter: this.filter});
        }
    }

    // handleFilter(name, value) {
    //     if(name === "isMan"){
    //         let filter = {...this.state.filter, [name]: value, isWoman: false, isCouple: false, isTrans: false, page: 1};
    //         this.setState({filter});
    //         this.getMedias(filter);
    //     } else if(name === "isWoman"){
    //         let filter = {...this.state.filter, [name]: value, isMan: false, isCouple: false, isTrans: false, page: 1};
    //         this.setState({filter});
    //         this.getMedias(filter);
    //     } else if(name === "isCouple"){
    //         let filter = {...this.state.filter, [name]: value, isWoman: false, isMan: false, isTrans: false, page: 1};
    //         this.setState({filter});
    //         this.getMedias(filter);
    //     } else if(name === "isTrans"){
    //         let filter = {...this.state.filter, [name]: value, isWoman: false, isCouple: false, isMan: false, page: 1};
    //         this.setState({filter});
    //         this.getMedias(filter);
    //     } else {
    //         let filter = {...this.state.filter, [name]: value, page: 1};
    //         this.setState({filter});
    //         this.getMedias(filter);
    //     }
    // }

    handleFilter(name, value) {
        if(name === "Homme" || name === "Femme" || name === "Couple" || name === "Travesti"){
            let gender = [...this.state.filter.gender];

            let indexList = config.genderList.indexOf(name);
            let index = gender.indexOf(indexList);
            if(index >=0){
                gender.splice(index, 1);
            }
            else{
                gender.push(indexList);
            }

            let filter = {...this.state.filter,gender, page: 1};
            this.setState({filter});
            this.getMedias(filter);
        }
        else if(name === "sort"){
            let filter = {...this.state.filter, [name]: value, page: 1};
            if(value === 0){
                filter = {...filter, period: 1};
            }
            this.setState({filter});
            this.getMedias(filter);
        }
        else {
            let filter = {...this.state.filter, [name]: value, page: 1};
            this.setState({filter});
            this.getMedias(filter);
        }
    }

    isToogleGender(name){
        let gender = [...this.state.filter.gender];
        let indexList = config.genderList.indexOf(name);
        let index = gender.indexOf(indexList);
        return index >= 0 ? true : false;
    }


    handlePeriod(period, currentYear, currentMonth) {
        let filter = {...this.state.filter, page: 1};
        if (period === 3) {
            currentYear = filter.currentYear !== "" ? currentYear : new Date().getFullYear();
            currentMonth = filter.currentMonth !== "" ? currentMonth : new Date().getMonth() + 1;
            filter = {...filter,  period, currentYear, currentMonth};

        }
        else {
            filter = {...filter, period, currentYear: "", currentMonth: ""};
        }
        this.setState({filter});
        this.getMedias(filter);
    }

    getMedias(filter) {
        let query = {...filter};

        this.props.fetchMedias(this.aqp.set(query));
    }

    handleChangePage(page) {
        let filter = {...this.state.filter, page};
        this.setState({filter});
        this.getMedias(filter);
        window.scrollTo(0, 0);
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        if(this.props.mediasTotal !== nextProps.mediasTotal){
            return true;
        }
        if(this.props.match.params !== nextProps.match.params){
            return true;
        }
        if(this.props.lastUpdate !== nextProps.lastUpdate){
            return true;
        }
        // if(this.props.medias !== nextProps.medias){
        //     return true;
        // }
        if(this.state === nextState && !this.props.mediasLoading){
            return nextProps.mediasInitialized !== this.props.mediasInitialized;
        } else return true;
    }


    render() {
        let totalPage = this.props.medias ? Math.ceil(this.props.mediasTotal / this.state.filter.limit) : 0;
        let url = this.aqp.queryUrl(this.state.filter, mapping);
        let currentPage = parseInt(this.state.filter.page);

        //url.search = url.search.replace("?createur=true", "");

        return !this.props.mediasInitialized ? (
            <div id="gallery">
                <div className="container">
                    <div className="card big">
                        <PageLoader/>
                    </div>
                </div>
            </div>
        ) : (
            <div id="gallery">
                <Helmet>
                    <title>Photo Sexe et Contribution Exhib Amateur {currentPage >1 ? `( page ${currentPage} )` : ""}</title>
                    <meta name="description" content={"Retrouvez chaque minute les nouvelles contributions photos d'amatrices sur Voissa. Les photos des membres sont très variées, exhib coquines et sexy, parfois hard, retrouvez ces membres et suivez-les au quotidien sur Voissa."} />
                    <meta name="keywords" content={"photo perso sexy, exhib amateur, photo sexe amateur, contribution amateur, photo amatrice, exhib nue, photo femme nue"} />
                    {currentPage === 2 && (<link rel="prev" href={canonical(url.link, url.search, "photos") }/>)}
                    {currentPage >= 3 && (<link rel="prev" href={canonical(`${url.link}/${(currentPage - 1)}`, url.search, "photos")} />)}
                    <link rel="canonical" href={currentPage >1 ? canonical(`${url.link}/${currentPage}`, url.search, "photos") : canonical(url.link, url.search, "photos")} />
                    {currentPage < totalPage && (<link rel="next" href={canonical(`${url.link}/${(currentPage +1)}`, url.search, "photos")} />)}
                </Helmet>
                <Can action={"qualification"} subject="TagModeration">
                    <TagModerationQualificationWarning />
                </Can>
                <div className="container">
                    <Advertising sizeMobile={"300x100"} className={"center"} />
                    <div className="card big">
                        <div className="card-controls">
                            <div className="main-controls-row">
                                <Title heading={"heading-1"} display={"display-2"}>
                                    Toutes les photos
                                </Title>
                                <div className="filters">
                                    <Dropdown align="right" activableComponent={(
                                        <Button size={"small"}
                                                icon={"sliders"}
                                                content={"Filtres"}/>
                                    )}>
                                        <ul className="dropdown-menu">
                                            <li className="menu-item">Les voissa Créateurs<Toggle
                                                isToggled={this.state.filter.isCreator}
                                                onToggle={() => this.handleFilter("isCreator", !this.state.filter.isCreator)}/>
                                            </li>
                                            {this.props.currentUserInitialized &&
                                            <li className="menu-item">Mes ami(e)s<Toggle
                                                isToggled={this.state.filter.isFriends}
                                                onToggle={() => this.handleFilter("isFriends", !this.state.filter.isFriends)}/>
                                            </li>
                                            }
                                            <li className="menu-item">Les hommes<Toggle
                                                isToggled={this.isToogleGender("Homme")}
                                                onToggle={() => this.handleFilter("Homme", !this.state.filter.isMan)}/>
                                            </li>
                                            <li className="menu-item">Les femmes<Toggle
                                                isToggled={this.isToogleGender("Femme")}
                                                onToggle={() => this.handleFilter("Femme", !this.state.filter.isWoman)}/>
                                            </li>
                                            <li className="menu-item">Les couples<Toggle
                                                isToggled={this.isToogleGender("Couple")}
                                                onToggle={() => this.handleFilter("Couple", !this.state.filter.isCouple)}/>
                                            </li>
                                            <li className="menu-item">Les Trans / Trav<Toggle
                                                isToggled={this.isToogleGender("Travesti")}
                                                onToggle={() => this.handleFilter("Travesti", !this.state.filter.isTrans)}/>
                                            </li>
                                        </ul>
                                    </Dropdown>
                                    <Can action={"upload"} subject="Media">
                                        <Button className={"access-upload-btn"}
                                                size={"small"}
                                                btnStyle={"primary-reverse"}
                                                onClick={() => this.setState({toggleUpload: true})}
                                                content={'Envoyer ma photo'}/>
                                        <Modal toggle={this.state.toggleUpload}
                                               handleClose={() => this.setState({toggleUpload: false})}>
                                            <Upload handleClose={() => this.setState({toggleUpload: false})}/>
                                        </Modal>
                                    </Can>
                                </div>
                            </div>

                            <div className={"sub-controls-row"}>
                                <h3 className={"sub-controls-row-link sort-row-link"}>
                                    {this.sort.map(item=><span key={item.id} className={this.state.filter.sort === item.id ? 'active' : ''} onClick={() => this.handleFilter("sort",item.id)}>{item.title}</span>)}
                                </h3>
                            </div>
                            {this.state.filter.sort !== 0 ? (
                                <SubControls handlePeriod={this.handlePeriod}
                                     period={this.state.filter.period}
                                     currentYear={this.state.filter.currentYear}
                                     currentMonth={this.state.filter.currentMonth}/>
                            ) : null}



                            <div className="column">
                                <ul className="photo-tags-wrapper">
                                    {this.state.currentMediaTagIndex === 0 ? (
                                        <Fragment>
                                            {this.mediaTagsRandom.map((photoTagRandom, index) => (
                                                <li className={this.state.currentTagIndex === index ? 'active' : ''}
                                                    onClick={() => this.handleCurrentTagIndex(index)}
                                                    key={index}>#{photoTagRandom}</li>
                                            ))}
                                        </Fragment>
                                    ) : this.state.currentMediaTagIndex === 1 && (
                                        <Fragment>
                                            {this.mediaTagsPopular.map((photoTagPopular, index) => (
                                                <li key={index}>#{photoTagPopular}</li>
                                            ))}
                                        </Fragment>
                                    )}
                                </ul>
                            </div>
                        </div>
                        {this.props.mediasLoading && (
                            <LoadingBar />
                        )}
                        {totalPage > 1 &&
                        <Pagination
                            className={"mt-0 mb-16"}
                            currentPage={this.state.filter.page}
                            pagesCount={totalPage}
                            handleChangePage={this.handleChangePage}
                            {...this.aqp.queryUrl(this.state.filter, mapping)}
                        />
                        }
                        <div className="thumbs-grid">
                            {Array.isArray(this.props.medias) && this.props.medias.map((media) => (
                                <Thumb key={media._id} {...media} cropTitle={45} />
                            ))}
                            {this.props.mediasTotal === 0 && (
                                <div className={"no-content"}>Il n'y a aucune photo</div>
                            )}
                        </div>
                        {totalPage > 1 &&
                            <Pagination
                                currentPage={this.state.filter.page}
                                pagesCount={totalPage}
                                handleChangePage={this.handleChangePage}
                                {...this.aqp.queryUrl(this.state.filter, mapping)}
                            />
                        }
                        {this.state.filter.page === 1 ? (
                            <div className={"footer-medias"}>
                                <p>Beaucoup de Voissanautes choisissent la photo pour s'exhiber : <strong>Photo sexe</strong> ou coquine, habillé ou nu... chacun peut s'épanouir à son rythme sur Voissa en fonction de ses envies.</p>
                                <p>Revenez régulièrement car vous verrez que les mises à jour sont incessantes et que les <strong>contributions amateur</strong> sont faites pour vous plaire, donner envie de commenter et offrir un "j'aime".</p>

                                <p><span>Des photos sexe ? Oui mais surtout de l'exhib amateur et des contributions réalisées avec passion !</span></p>

                                <p>A l'aide des différents tags, retrouvez les albums de photos qui vont vous plaire :
                                    Fétichisme, en couple, sodomie, dans la cuisine, amateur, en bikini, gros seins (et
                                    petits seins bien sûr), sextoy, en trio (et parfois même plus), en uniforme, dans la
                                    piscine, dans la nature, à la plage, certaines femmes sont même tatouées, sadomaso, en
                                    lingerie et bien plus.</p>

                                <p>Beaucoup de photos plairont aux amateurs de jolies femmes exhib, de jolis couples, mais
                                    sur Voissa beaucoup d'hommes produisent également un contenu de grande qualité, en
                                    valorisant des clichés de leur torse et de leurs fesses plutôt que de leur pénis en gros
                                    plan.</p>

                                <p>Vos photos et vos snaps ne peuvent plus rester bloqués sur votre téléphone portable (ou
                                    votre ordinateur), écoutez vos désirs et partagez les avec notre communauté, nous vous
                                    attendons parmi nous sur Voissa.</p>

                            </div>
                        ) : null
                        }
                    </div>
                </div>
                <MobileLiveTool/>
            </div>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        medias: state.medias.data,
        lastUpdate : state.medias.lastUpdate || 0,
        mediasLoading: state.medias.loading,
        mediasInitialized: state.medias.initialized,
        mediasTotal: state.medias.total
    }
};

const mapDispatchToProps = {
    fetchMedias,
    resetMedias
};

export default connect(mapStateToProps, mapDispatchToProps)(Photo);
